import React from "react";
import DataTable, { MUIDataTableOptions } from "mui-datatables";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import * as Dati from "../../../Dati";
import { _TableLoader } from "..";
import { GetEconomicDataListColumns } from "./EconomicDataListColumns";

const useStyles = makeStyles(({ spacing }: Theme) => ({
    tableWrapper: {
        marginTop: spacing(4),
        position: "relative"
    }
}));

interface IEconomicDataListTableProps {
    BaseUrl: string;
    Data: Dati.CRisAPIPaginePolizza | undefined;
    Options: MUIDataTableOptions;
    IsLoading: boolean;
}

export const _EconomicDataListTable: React.FC<IEconomicDataListTableProps> = React.memo(({ BaseUrl, Data, Options, IsLoading }) => {
    const classes = useStyles();

    return (
        <Box className={classes.tableWrapper}>
            {IsLoading && <_TableLoader />}
            <DataTable title="" data={Data?.Dati || []} columns={GetEconomicDataListColumns(BaseUrl)} options={Options} />
        </Box>
    );
});



// WEBPACK FOOTER //
// ./src/inar2/components/EconomicDataList/EconomicDataListTable.tsx